// 外部ファイル読み込み
import modal from './module/modal';

(() => {
	// eslint-disable-next-line no-console
	// ============================================
	// iframeに親要素追加
	// ============================================
	const iframeWrap = () => {
		document.querySelectorAll('iframe').forEach((iframe) => {
			if (iframe.closest('.iframe-wrap')) return; // 既に.iframe-wrapがある場合はスキップ

			const wrapper = document.createElement('div'); //追加するHTML要素
			wrapper.className = 'iframe-wrap'; //追加するクラス名

			// wrapperをiframeの前に挿入
			iframe.parentNode.insertBefore(wrapper, iframe);
			wrapper.appendChild(iframe);
		});
	};
	// ============================================
	// wpボタンにspanとアイコン追加
	// ============================================
	const buttonIcon = () => {
		document.querySelectorAll('a.wp-block-button__link').forEach((a) => {

			// txtが未作成の場合
			if (!a.querySelector('.txt')) {
				// aタグ内のテキストを取得
				const text = a.textContent.trim();
				// テキストをクリア
				a.textContent = '';
				// txt用span作成
				const txt = document.createElement('span');
				txt.className = 'txt';
				txt.textContent = text;
				a.appendChild(txt);
			}

			// arrowが未作成の場合
			if (!a.querySelector('.arrow')) {
				const arrow = document.createElement('span');
				arrow.className = 'arrow';
				a.appendChild(arrow);
			}
		});
	};

	// ============================================
	// aタグ付きのギャラリーにモーダルを追加
	// ============================================
	const galleryModal = () => {

		// ギャラリーブロック内のリンクを取得
		const galleryLinks = document.querySelectorAll(
			'.wp-block-gallery a'
		);

		// ギャラリーが存在しない場合は終了
		if (!galleryLinks.length) return;

		// ギャラリー画像ごとにモーダルを生成
		galleryLinks.forEach((link, index) => {

			// aタグ内の画像要素を取得
			const image = link.querySelector('img');

			// 画像が存在しない場合はスキップ
			if (!image) return;

			// モーダル用の一意なIDを作成
			const modalId = `gallery-${index + 1}`;

			// 元画像URLを取得
			const imageUrl =
				image.dataset.src ||
				image.dataset.lazySrc ||
				image.dataset.original ||
				image.currentSrc ||
				image.src;

			// alt属性を取得してモーダル側にも引き継ぐ
			const imageAlt = image.getAttribute('alt') || '';

			// 既存モーダルJS用の属性を付与
			link.setAttribute('data-modal-trigger', modalId);

			// 通常のリンク遷移を無効化
			link.addEventListener('click', event => {
				event.preventDefault();
			});

			// モーダル本体を生成
			const modal = document.createElement('div');

			// class付与
			modal.className = 'modal';

			// モーダル識別用属性
			modal.setAttribute('data-modal-target', modalId);

			// フェードアニメーション指定
			modal.setAttribute('data-modal-animation', 'fade');

			// 初期状態は閉じる
			modal.setAttribute('data-modal-active', 'false');

			// ----------------------------
			// モーダルHTML生成
			// ----------------------------
			modal.innerHTML = `
			<div
				class="modal__wrap"
				data-modal-close
				data-modal-animationTrigger
			>

				<button
					class="modal__close"
					data-modal-close
					type="button"
				>
					<span class="icon"></span>
				</button>

				<div
					class="modal__content"
					data-modal-content
				>
					<img
						src="${imageUrl}"
						alt="${imageAlt}"
					>
				</div>

			</div>
		`;
			// ----------------------------
			// bodyの最後にモーダルを追加
			// ----------------------------
			document.body.appendChild(modal);
		});
	};

	// ============================================
	//実行
	// ============================================
	iframeWrap();
	buttonIcon();
	galleryModal();
	// 外部ファイル実行
	modal();
})();
